(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '{{amount}} kr';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function initProduct(root) {
    if (root.__duReady) return;
    root.__duReady = true;

    var jsonEl = root.querySelector('[data-du-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var variants = data.variants || [];
    var form = root.querySelector('[data-du-form]');
    var idInput = root.querySelector('[data-du-variant-input]');
    var addBtn = root.querySelector('[data-du-add]');
    var stickyBtn = root.querySelector('[data-du-add-sticky]');
    var gallery = root.querySelector('[data-du-gallery]');
    var counter = root.querySelector('[data-du-counter]');

    // ---------- Variant selection ----------
    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-du-option]:checked').forEach(function (input) {
        opts[Number(input.getAttribute('data-du-option'))] = input.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      });
    }

    function updateUI(variant) {
      var opts = selectedOptions();
      opts.forEach(function (val, i) {
        var label = root.querySelector('[data-du-opt-label="' + i + '"]');
        if (label) label.textContent = val;
      });

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-label-soldout'); }
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }

      if (idInput) idInput.value = variant.id;
      root.querySelectorAll('[data-du-price]').forEach(function (el) {
        el.textContent = formatMoney(variant.price, data.moneyFormat);
      });
      var compare = root.querySelector('[data-du-compare]');
      if (compare) {
        compare.textContent = variant.compare_at_price && variant.compare_at_price > variant.price
          ? formatMoney(variant.compare_at_price, data.moneyFormat) : '';
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
      }
      if (stickyBtn) stickyBtn.disabled = !variant.available;

      if (variant.featured_media && gallery) {
        var item = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (item) {
          if (window.matchMedia('(max-width: 989px)').matches) {
            gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
          } else {
            gallery.prepend(item);
          }
        }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-du-option]')) return;
      updateUI(findVariant(selectedOptions()));
    });

    // Show the selected variant's image first on load
    var first = gallery && gallery.querySelector('[data-first]');
    if (first && first !== gallery.firstElementChild && !window.matchMedia('(max-width: 989px)').matches) {
      gallery.prepend(first);
    }

    // ---------- Mobile gallery counter ----------
    if (gallery && counter) {
      var total = gallery.children.length;
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
        counter.textContent = Math.min(i, total) + ' / ' + total;
      }, { passive: true });
    }

    // ---------- Add to cart (AJAX with redirect fallback) ----------
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var errorEl = root.querySelector('[data-du-error]');
        if (errorEl) errorEl.textContent = '';
        if (addBtn) addBtn.setAttribute('aria-busy', 'true');
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
          .then(function (r) {
            if (addBtn) addBtn.removeAttribute('aria-busy');
            if (!r.ok) {
              if (errorEl) errorEl.textContent = r.json.description || r.json.message || 'Something went wrong.';
              return;
            }
            // Let themes with a cart drawer react, then fall back to the cart page
            var evt = new CustomEvent('du:cart:added', { bubbles: true, cancelable: true, detail: r.json });
            if (document.dispatchEvent(evt)) {
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            }
          })
          .catch(function () { form.submit(); });
      });
    }

    // ---------- Sticky bar ----------
    var sticky = root.querySelector('[data-du-sticky]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
          var btn = sticky.querySelector('button');
          if (btn) btn.tabIndex = past ? 0 : -1;
        });
      });
      io.observe(addBtn);
    }

    // ---------- Delivery countdown ----------
    root.querySelectorAll('[data-du-countdown]').forEach(function (el) {
      var textEl = el.querySelector('[data-du-countdown-text]');
      var cutoff = Number(el.getAttribute('data-cutoff')) * 60;
      var tz = el.getAttribute('data-tz') || 'Europe/Copenhagen';

      function tick() {
        var parts;
        try {
          parts = new Intl.DateTimeFormat('en-GB', { timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false })
            .formatToParts(new Date());
        } catch (err) { return; }
        var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
        var day = get('weekday');
        var now = Number(get('hour')) % 24 * 60 + Number(get('minute'));
        var weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(day) !== -1;
        var left = cutoff - now;

        if (!weekday || left <= 0) {
          textEl.textContent = el.getAttribute('data-closed');
          return;
        }
        var h = Math.floor(left / 60);
        var m = left % 60;
        var time = (h > 0 ? h + ' ' + el.getAttribute('data-hours') + ' ' : '') + m + ' ' + el.getAttribute('data-minutes');
        var after = day === 'Fri' ? el.getAttribute('data-after-friday') : el.getAttribute('data-after');
        textEl.innerHTML = '';
        textEl.append(el.getAttribute('data-before') + ' ');
        var b = document.createElement('strong');
        b.textContent = time;
        textEl.append(b, ' ' + after);
      }
      tick();
      setInterval(tick, 30000);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-du-product-section]').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
